(function () {
  if (window.__viralVeraCartUpsellRefreshFix) return;
  window.__viralVeraCartUpsellRefreshFix = true;

  const CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/;
  const CART_UPSELL_SELECTOR = 'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift';

  let refreshTimer = null;
  let isRefreshing = false;

  function requestPath(input) {
    try {
      const rawUrl = typeof input === 'string' ? input : input && input.url;
      if (!rawUrl) return '';
      const url = new URL(rawUrl, window.location.origin);
      return url.pathname + url.search;
    } catch (error) {
      return '';
    }
  }

  function scheduleCartDrawerRefresh(delay) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshCartDrawer, delay || 500);
  }

  async function refreshCartDrawer() {
    if (isRefreshing) {
      scheduleCartDrawerRefresh(350);
      return;
    }

    const cartDrawer = document.querySelector('cart-drawer');
    if (
      !cartDrawer ||
      typeof cartDrawer.getSectionsToRender !== 'function' ||
      typeof cartDrawer.renderContents !== 'function' ||
      !window.routes ||
      !window.routes.cart_url
    ) {
      return;
    }

    const sectionIds = cartDrawer
      .getSectionsToRender()
      .map((section) => section.id)
      .join(',');

    if (!sectionIds) return;

    isRefreshing = true;

    try {
      const response = await window.fetch(`${window.routes.cart_url}?sections=${sectionIds}`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();

      cartDrawer.renderContents(
        {
          id: `cart-upsell-refresh-${Date.now()}`,
          sections,
        },
        true
      );
    } catch (error) {
      console.warn('Cart upsell refresh failed', error);
    } finally {
      isRefreshing = false;
    }
  }

  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    const shouldRefresh = CART_MUTATION_RE.test(requestPath(args[0]));
    const responsePromise = originalFetch.apply(this, args);

    if (shouldRefresh) {
      responsePromise
        .then((response) => {
          if (response && response.ok) scheduleCartDrawerRefresh(700);
        })
        .catch(() => {});
    }

    return responsePromise;
  };

  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest(CART_UPSELL_SELECTOR)) {
        scheduleCartDrawerRefresh(1000);
      }
    },
    true
  );

  document.addEventListener('cartQuantityUpdated', function () {
    scheduleCartDrawerRefresh(350);
  });
})();
